var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar"},_vm._l((_vm.tabs),function(tab){return _c('div',{staticClass:"button-container"},[_c('tab-button',{attrs:{"active":tab.id === _vm.activeItemId,"label":tab.label,"id":tab.id,"type":_vm.type},on:{"clicked":_vm.clicked}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8484468","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/form/TabBar.vue
// module id = LMa+
// module chunks = 1